export default {
  // Application title
  'application-name': 'mySGbuilding',
  // Internal/unknown error
  internalError: 'Une erreur est survenue',
  internalErrorMessage:
    'Nous ne pouvons pas compléter votre demande pour le moment.',
  internalErrorContact: 'Contactez nous',
  internalErrorTryAgain: 'Réessayer',
  // Page not found
  notFound: 'Page non trouvée.',
  notFoundMessage: "Désolé, nous n'avons pas trouvé cette page",
  notFoundContact: 'Contactez nous',
  notFoundGoBack: 'Retour',
  close: 'Fermer',
  cancel: 'Annuler',
  confirm: 'Confirmer',
  firstName: 'Prénom',
  lastName: 'Nom',
  days: {
    MONDAY: 'Lundi',
    TUESDAY: 'Mardi',
    WEDNESDAY: 'Mercredi',
    THURSDAY: 'Jeudi',
    FRIDAY: 'Vendredi',
    SATURDAY: 'Samedi',
    SUNDAY: 'Dimanche',
  },
  // Home page
  home: {
    'welcome-title': 'Bienvenue sur MyBuilding',
    'country-dropdown': 'Pays',
    'site-dropdown': 'Site',
    'building-dropdown': 'Bâtiment',
    'dropdown-select': 'Sélectionner',
    'dropdown-goToServices': 'Accéder au bâtiment',
  },
  qrCode: {
    help:
      "Retrouver l'application dans sa version mobile en scannant le QR code.",
  },
  header: {
    selectSiteCancel: 'Annuler',
    changeSiteTitle: 'Changer de lieu',
    selectSiteTitle: 'Sélectionnez votre lieu',
    home: 'Accueil',
    changeSite: 'Changer de site',
  },
  smartBuilding: {
    favourites: 'Mes favoris',
    location: 'Sélectionner le bâtiment',
    workspaces: 'Espaces de travail',
    selectBuilding: 'Selectionnez un batiment',
    choice: 'Choix du site',
    selectBuildingHome:
      'Sélectionnez un site (liste à gauche) puis un bâtiment (liste à droite)',
    selectBuildingDomotic: 'Sélectionnez un bâtiment et un étage',
    building: 'Bâtiments',
    floor: 'Étage',
    room: 'Salle ou emplacement',
    noFavourites: 'Pas de favoris',
    addFavourites: 'Ajouter aux favoris',
    deleteFavourites: 'Retirer des favoris',
    selectSite: "Sélectionnez votre emplacement à l'aide du menu sur la gauche",
    remoteControl: {
      temperature: 'Température',
      degree: 'degrés',
      offset: 'Variation : ',
      lighting: 'Éclairage',
      blinds: 'Stores',
      blind: 'Store',
      group: 'Groupe',
      all: 'Tous',
    },
  },
  reservation: {
    workstationReservation: 'Réserver un poste',
    ReserveNextTo: 'Réserver à coté de',
    myShares: 'Mes partages',
    bookNextTo: 'Réserver à côté de',
    MyReservation: 'Mes réservations',
    modify: 'Modifier',
    viewOnMap: 'Visualiser sur les plans',
    cancelBooking: 'Annuler ma réservation',
    modifyModalTitle: 'Quel événement souhaitez-vous modifier ?',
    modifyModalDescription:
      'Vous pouvez modifier cet événement seulement ou cet événement et tous les suivants',
    modifyModalSerie: 'La série',
    modifyModalOccurrence: "L'occurrence",
    deskNumber: 'Bureau N°{number}',
    tabs: {
      date: 'Date',
      searchCollaborator: 'Rechercher un collaborateur',
      collaborateurShareWitYou:
        'Les collaborateurs qui partagent leurs réservations avec vous',
      myShares: 'Mes partages',
      sharesReceived: 'Mes partages reçus',
      myReservations: 'Mes réservations de postes de travail',
      building: 'Immeuble',
      workstation: 'Bureau',
      duration: 'Durée',
      recurrence: 'Récurrence',
      days: 'Jours',
      actions: 'Actions',
      search: 'Rechercher',
      service: 'Service',
      thisWeek: 'Cette semaine',
      weeks: 'Pendant {weeks} semaines',
      book: 'Réserver',
    },
    confirmCancelling: 'Voulez-vous annuler cette réservation ?',
    success: {
      title: 'Confirmation de votre réservation',
      description: 'Votre réservation a été réalisée avec succès',
      modified: 'Votre réservation a été modifiée avec succès',
      bookedNear:
        'Votre réservation à côté de {name} a été réalisée avec succès',
      sharingTitle: 'Confirmation de votre partage',
      sharingDescription:
        'Le partage de vos réservations avec {name} a été ajouté avec succès',
    },
    delete: {
      title: 'Confirmer la suppression',
      sharingDescription:
        'Voulez-vous vraiment supprimer ce collaborateur de vos partages ?',
    },
    error: {
      title: 'Erreur lors de votre réservation',
      description: 'Vous avez déjà réservé pour cette journée',
    },
    timeSlots: {
      ALL_DAY: 'Journée entière',
      MORNING: 'Matin',
      AFTERNOON: 'Après-midi',
      INDIFFERENT: 'Indifférent',
    },
    recurrence: {
      '1': 'Une semaine',
      '2': 'Deux semaines',
      '3': 'Trois semaines',
      '4': 'Quatre semaines',
    },
    chooseOnMap: "Veuillez choisir sur la carte, l'emplacement souhaité",
    nextTo: {
      sharingCollaborators:
        'Les collaborateurs qui partagent leur réservation avec vous',
      nbBookingToday: "{nb} résa aujourd'hui",
    },
  },
  availableDesks: {
    leftPartTitle: 'Bâtiments',
    rightPartTitle: 'Étages -',
    squareFree: 'Libre',
    squareMedium: 'Moyen',
    squareFull: 'Plein',
    availablePlace: 'places disponibles sur',
    floors: 'Étages',
  },
  servicesTitles: {
    domotique: 'Domotique',
    bureauxDispo: 'Bureaux disponibles',
    activateBooking: 'Réservation de poste',
  },
  servicesDescription: {
    domotique:
      'Gérez la température, les stores et la lumière de votre environnement de travail.',
    bureauxDispo: 'Trouvez et vérifiez la disponibilité des postes de travail',
    laVallee:
      "Visualisez l'affluence des espaces de la Vallée ainsi que les informations pratiques de chaque espaces.",
    reservation:
      'Réserver un poste de travail de façon ponctuelle ou régulière.',
  },
  servicesImgAltName: {
    domotique: 'Logo domotique',
    bureauxDispo: 'Logo bureaux disponibles',
    laVallee: "Logo de l'affluence de la Vallée",
    reservation: 'Logo de réservation de poste',
  },
  input: {
    select: {
      selectAll: 'Tout séléctionner',
      selectAllSites: 'Tous les sites',
      noResult: 'Aucun résulat',
    },
  },
  footer: {
    siteMap: 'Plan du site',
    Accessibility: 'Accessibilité non conforme',
    Legal: 'Mentions Légales',
    ContactPhone: 'Contact SAU mySGbuilding par téléphone :',
    Phone: '73000 (+33 1 56 373 000), option 4',
    ContactEmail: 'Contact SAU mySGbuilding par mail :',
    Email: 'sau-mybuilding.par@socgen.com',
    cookies: 'Cookies',
  },
  // Getting started page
  'get-started': {
    title: "Commencez avec l'application React Whiteapp",
    description:
      "Si vous voyez cet écran, cela signifie que vous avez récupéré avec succès <a href='https://apps.bsc.aws.societegenerale.com/gitlab/dex/frontend/react-whiteapp/'> React Whiteapp </a>. Alors, qu'est-ce qui est inclus dans cette application ?",
    note:
      'Notez que la Whiteapp est périodiquement mise à niveau avec les dernières dépendances. Essayez de garder votre application à jour avec <code>yarn upgrade --latest</code>.',
    'issue-title':
      'Vous rencontrez un problème avec la Whiteapp? Vous avez des commentaires à ce sujet ?',
    'issue-button': 'Créer un ticket de support',
    contribute:
      "Si vous souhaitez améliorer ou résoudre un problème  vous pouvez créer une Merge Request sur le <a href='https://apps.bsc.aws.societegenerale.com/gitlab/dex/frontend/react-whiteapp'> Gitlab DEX</a>.",
    getStartedIncluded: {
      'get-started-choice-1':
        "<a href='https://sgithub.fr.world.socgen/pages/sgbootstrap/sg-bootstrap-v4/master/demo/'>SG Bootstrap v4</a>: Système de conception officiel (pour ITEC & BSC) basé sur <a href='https://getbootstrap.com/docs/4.3/getting-started/introduction/'>Bootstrap v4</a>",
      'get-started-choice-2':
        "<a href='https://material.io/tools/icons/?style=baseline'>Material icons</a>",
      'get-started-choice-3':
        "<a href='https://reactstrap.github.io/'>Reactstrap</a>: Implémentation de composants React avec une base bootstrap",
      'get-started-choice-4':
        "Avec <a href='https://sgithub.fr.world.socgen/DT-Widgets/sgwt-widgets'>SGWidgets</a> : <code>sgwt-account-center</code> &amp; <code>sgwt-mini-footer</code>",
      'get-started-choice-5':
        "<a href='https://developer.sgmarkets.com/resources/sgconnect/toc.html'>SG Connect</a> authentication merci à <code>@sgwt/connect-core</code> &amp; <code>sgwt-connect</code> widget",
      'get-started-choice-6':
        "<a href='https://developer.sgmarkets.com/resources/sgmonitoring/web-analytics/web-analytics-main.html'>Matomo/Piwik</a> connecteur: une solution d'analyse Web",
      'get-started-choice-7':
        "<a href='https://reacttraining.com/react-router/'>React router</a> React",
      'get-started-choice-8':
        "<a href='https://github.com/formatjs/react-intl'>React intl</a>: Cette bibliothèque fournit des composants React et une API pour formater les dates, les nombres et les chaînes, y compris la pluralisation et la gestion des traductions.",
      'get-started-choice-9':
        "<a href='https://easy-peasy.now.sh/'>Easy-peasy</a>: C'est une gestion d'état d'application réactive basée sur Redux mais sans le boilerplate",
      'get-started-choice-10':
        "<a href=''>Openshift</a> support: Les variables d'environnement sont externalisées à l'intérieur du fichier <code>env.js</code> pour gérer différentes valeurs entre les environnements HOMOL et PROD malgré le mode <code>promote</code>",
      'get-started-choice-11':
        "<a href='https://docs.gitlab.com/ee/ci/'>Gitlab-ci.yml</a> Template: Si vous choisissez d’héberger votre projet sur <a href='https://apps.bsc.aws.societegenerale.com/gitlab/'>Gitlab</a>",
    },
  },
  maps: {
    globalView: 'Vue quartier',
    domotic: 'Domotique',
    itinerary: 'Itinéraire',
    fromThisPoint: 'A partir de ce lieu',
    toThisPoint: 'Vers ce lieu',
    information: 'Informations !',
    itineraryDescription:
      'Vous pouvez supprimer votre choix ou en re-choisir un directement sur la carte',
    startingPoint: 'A partir de ce lieu',
    endingPoint: 'Vers ce lieu',
    delete: 'Supprimer',
    previous: 'Précédent',
    next: 'Suivant',
    steps: 'Étape {currentStep} sur {allSteps}',
    direction: 'Itinéraire partant de {start} vers {end}',
    selectBuilding: 'Sélectionner bâtiment - étage',
    spaceName: 'Espace {space}',
    building: 'Bâtiment',
    floor: 'Etage',
    availability: 'Disponibilité',
    available: 'Disponible',
    temporarilyAvailable: 'Déjà occupé aujourd’hui',
    unavailable: 'Occupé',
    statusUnknown: 'Statut capteur indisponible',
    fixedDesk: 'Bureau sédentaire',
    floorPlan: {
      localisation: 'Localisation',
      legend: 'Légende',
      deskAvailable: 'Bureau disponible',
      deskOccupiedToday: "Bureau déjà occupé aujourd'hui",
      deskOccupied: 'Bureau occupé',
      sensorUnavailable: 'Capteur indisponible',
      meetingRoom: 'Salle de réunion',
      groundFloor: 'RDC (RP)',
      floorLabel: 'Étage {level}',
      desksAvailable: '{available} bureaux disponibles sur {total}',
      floorTitle: '{floor} — Étage {level}',
      loading: 'Chargement du plan\u2026',
      planUnavailable: 'Plan non disponible ({id})',
      site: 'Site',
      building: 'Immeuble',
      zone: 'Bâtiment',
      floor: 'Étage',
    }
  },
  cookies: {
    title: 'À propos des cookies',
    close: 'Refuser et fermer',
    description:
      'Certaines fonctionnalités de ce site peuvent utiliser des cookies pour améliorer votre expérience de navigation, par exemple pouvoir retrouver vos favoris.',
    personalize: 'Personnaliser',
    accept: 'Accepter',
    preferences: 'Préférences liées aux cookies',
    necessary: 'Cookies strictement nécessaires',
    functionality: 'Cookies de fonctionnalité',
    save: 'Enregistrer',
    acceptAll: 'Accepter tout',
    smartBuildings: {
      modalTitle: 'Fonctionnalité indisponible',
      modalDescription:
        'Vous devez accepter les cookies de fonctionnalité pour pouvoir ajouter des favoris',
    },
  },
  showFloorMap: 'Afficher le plan',
  isLoading: 'Chargement...'
};
